import axios from "axios";
import { API_MSHospitalBaseUrl, API_MOPCRMBASEURL } from "./common";

let baseURL1 = API_MSHospitalBaseUrl + "api";
const httpbaseURL = axios.create({
  baseURL: baseURL1,
});
let API_MOPCRMURL = API_MOPCRMBASEURL + "PlatformCoreServices/MOPCRM";

const httpMSMOPCRMUrl = axios.create({
  baseURL: API_MOPCRMURL,
});

/* Response Interceptors */
const interceptResErrors = (err) => {
  try {
    // check for response code 123 and redirect to login
    err = Object.assign(new Error(), { message: err.response.data });
  } catch (e) {
    // check for response code 123 and redirect to login
    // Will return err if something goes wrong
  }
  return Promise.reject(err);
};
const interceptResponse = (res) => {
  try {
    // check for response code 123 and redirect to login
    return Promise.resolve(res.data);
  } catch (e) {
    // check for response code 123 and redirect to login
    return Promise.resolve(res);
  }
};
httpbaseURL.interceptors.response.use(interceptResponse, interceptResErrors);
httpMSMOPCRMUrl.interceptors.response.use(
  interceptResponse,
  interceptResErrors
);
/* Request Interceptors */
const interceptReqErrors = (err) => Promise.reject(err);
const interceptRequest = (config) => {
  //debugger;
  let localStore: any = localStorage.getItem("user");
  localStore = JSON.parse(localStore);
  if (localStore != null) {
    let token: any = localStore["token"];
    let sessionId: any = localStore["SessionId"];
    config.headers["X-Auth-Token"] = `Bearer ${token}`;
    config.headers["SessionID"] = sessionId;
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
};
httpbaseURL.interceptors.request.use(interceptRequest, interceptReqErrors);
httpMSMOPCRMUrl.interceptors.request.use(interceptRequest, interceptReqErrors);
export default { httpbaseURL, httpMSMOPCRMUrl };
